var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlagGb = function SvgFlagGb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "flag_gb_svg__a",
    width: 16,
    height: 12,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v12H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#flag_gb_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E42A5",
    fillRule: "evenodd",
    d: "M0 0v12h16V0z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "flag_gb_svg__b",
    width: 16,
    height: 12,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0v12h16V0z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#flag_gb_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "flag_gb_svg__c",
    width: 16,
    height: 12,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v12H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#flag_gb_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m-1.781 11.143 3.52 1.489L16.08 1.619l1.857-2.213-3.765-.498-5.849 4.746-4.708 3.198z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    d: "m-1.299 12.186 1.794.864L17.27-.8h-2.519z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.781 11.143-3.52 1.489L-.08 1.619-1.937-.594l3.765-.498 5.849 4.746 4.708 3.198z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    d: "m17.66 11.891-1.794.864-7.143-5.93-2.118-.662-8.722-6.75H.402l8.717 6.59 2.315.794z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "flag_gb_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.889 4h7.125v4H9.889v5H6.11V8H-.986V4H6.11v-5H9.89z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F50100",
    d: "M9.889 4h7.125v4H9.889v5H6.11V8H-.986V4H6.11v-5H9.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.889 4h-1v1h1zm7.125 0h1V3h-1zm0 4v1h1V8zM9.889 8V7h-1v1zm0 5v1h1v-1zM6.11 13h-1v1h1zm0-5h1V7h-1zM-.986 8h-1v1h1zm0-4V3h-1v1zM6.11 4v1h1V4zm0-5v-1h-1v1zM9.89-1h1v-1h-1zm0 5v1h7.125V3H9.889zm7.125 0h-1v4h2V4zm0 4V7H9.889v2h7.125zM9.889 8h-1v5h2V8zm0 5v-1H6.11v2H9.89zM6.11 13h1V8h-2v5zm0-5V7H-.986v2H6.11zM-.986 8h1V4h-2v4zm0-4v1H6.11V3H-.986zM6.11 4h1v-5h-2v5zm0-5v1H9.89v-2H6.11zM9.89-1h-1v5h2v-5z",
    mask: "url(#flag_gb_svg__d)"
  }))))));
};
export default SvgFlagGb;